// --- Chakra Elements
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from "@chakra-ui/react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function BaseModal(_ref) {
  let {
    isOpen,
    onClose,
    children,
    size,
    title,
    footer,
    closeOnOverlayClick,
    hideCloseButton
  } = _ref;
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    closeOnOverlayClick: closeOnOverlayClick !== null && closeOnOverlayClick !== void 0 ? closeOnOverlayClick : true,
    size: size || "xl",
    isCentered: true,
    children: [/*#__PURE__*/_jsx(ModalOverlay, {}), /*#__PURE__*/_jsx(ModalContent, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [title && /*#__PURE__*/_jsx(ModalHeader, {
          px: 8,
          pb: 1,
          pt: 6,
          children: title
        }), (hideCloseButton === undefined || hideCloseButton === false) && /*#__PURE__*/_jsx(ModalCloseButton, {
          mr: 2
        }), /*#__PURE__*/_jsx(ModalBody, {
          p: 0,
          children: /*#__PURE__*/_jsx("div", {
            className: "p-6",
            children: children
          })
        }), footer && /*#__PURE__*/_jsx("div", {
          children: footer
        })]
      })
    })]
  });
}